import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ConfirmAccountForm } from '../components/auth/ConfirmAccountForm';

export const ConfirmAccountPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pageState = (location.state as { email?: string; participationSurveyId?: string; userId?: string; redirect?: string } | undefined) || {};
  const email = pageState.email || '';
  const participationSurveyId = pageState.participationSurveyId;
  const userId = pageState.userId || '';
  const redirect = pageState.redirect;

  const handleSuccess = () => {
    navigate('/login', {
      state: {
        message: 'Conta confirmada com sucesso! Faça login para continuar.',
        participationSurveyId,
        redirect,
      }
    });
  };

  const handleBackToLogin = () => {
    navigate('/login', {
      state: {
        participationSurveyId,
        redirect,
      },
    });
  };

  if (!email) {
    navigate('/register', {
      state: {
        participationSurveyId,
      },
    });
    return null;
  }

  return (
    <ConfirmAccountForm
      email={email}
      userId={userId}
      onSuccess={handleSuccess}
      onBackToLogin={handleBackToLogin}
    />
  );
};
